import type { FlowDefinition } from '../types';
import {
  findPreferredSectionLogicFlow,
  findSectionLogicFlow,
  upsertBlankSectionFlow,
} from './flowSectionHelpers';

type LayoutSection = {
  id: string;
  settings?: {
    canvas?: {
      blocks?: Array<{
        id: string;
        type: string;
      }>;
    };
  };
};

export function resolveOrCreateSectionInsertionFlow(
  flows: FlowDefinition[],
  args: {
    sectionId: string;
    sections?: LayoutSection[] | null;
  }
) {
  let nextFlows = flows;

  const section = args.sections?.find((entry) => entry.id === args.sectionId) ?? null;
  const sectionBlockIds = new Set(section?.settings?.canvas?.blocks?.map((block) => block.id) ?? []);
  const preferredFlow = findPreferredSectionLogicFlow(nextFlows, {
    sectionId: args.sectionId,
    blockIds: sectionBlockIds,
  });
  if (preferredFlow) {
    return {
      flows: nextFlows,
      flow: preferredFlow,
    };
  }

  nextFlows = upsertBlankSectionFlow(nextFlows, {
    sectionId: args.sectionId,
    name: 'Section Logic Flow',
  });

  return {
    flows: nextFlows,
    flow: findSectionLogicFlow(nextFlows, args.sectionId),
  };
}
